module.exports = __webpack_public_path__ + "img/avatar1.94e9e243.png";